import '../stylesheets/namespace/MagazineArticle.css'

import LazyLoad from 'vanilla-lazyload'
import { THRESHOLD, LOADED_SELECTOR } from '@/common/constants'

const lazyloadOptions = {
  elements_selector: '.ma-Article img',
  threshold: THRESHOLD,
  class_loaded: LOADED_SELECTOR
}

const runLazyLoad = () => {
  if (!window.lazyLoadInstance)
    window.lazyLoadInstance = new LazyLoad(lazyloadOptions)
  window.lazyLoadInstance.update()
}

const initMagazineActiclePage = () => {
  document.addEventListener('DOMContentLoaded', () => {
    runLazyLoad()
  })
}
initMagazineActiclePage()
